import { useState } from "react"
import { Button, Modal } from "react-bootstrap"
import FormField from "./FormField"

const DeleteConfirm = ({
	show,
	showDeleteConfirm,
	onConfirm,
	title,
	dialogText,
	payload,
	needExclusionDetails = false,
}) => {
	const [exclusionDetails, setExclusionDetails] = useState("")
	const dialogHandler = () => {
		if (typeof dialogText === "function" && payload) {
			return dialogText(payload)
		} else {
			return dialogText || "Deseja deletar esta opcao"
		}
	}
	const bodyRender = () => {
		return (
			<div className="d-flex flex-column gap-3">
				<div>
					<strong>{dialogHandler()}</strong>
				</div>
				{needExclusionDetails && (
					<div>
						<FormField
							label="Motivo"
							onValueUpdate={setExclusionDetails}
							val={exclusionDetails}
							asTextArea
							rows={3}
							onEnterPress={() =>enableConfirmAction() && onConfirm(exclusionDetails)}
						/>
					</div>
				)}
			</div>
		)
	}
	function enableConfirmAction ()  {
		if(!needExclusionDetails)return true
		else return exclusionDetails.length >= 8
	}
	return (
		<>
			<Modal show={show} onHide={() => showDeleteConfirm(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{bodyRender()}</Modal.Body>
				<Modal.Footer>
					<Button
						variant="secondary"
						onClick={() => showDeleteConfirm(false)}
					>
						Cancelar
					</Button>
					<Button
					disabled={!enableConfirmAction()}
					style={{pointerEvents: enableConfirmAction() ? 'auto' : 'none'}}
						variant="primary"
						type="submit"
						onClick={() => {
							onConfirm(exclusionDetails)
							showDeleteConfirm(false)
						}}
					>
						Confirmar
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default DeleteConfirm
